import React from 'react';
import {
  CpWidgetDidiverProps,
  CpWidgetDivider,
} from './cp-divider/cp-widget-divider';
import { CpWidgetRenderer, CpWidgetRendererProps } from './cp-widget-renderer';

type CpWidgetRendererWithDividerProps = CpWidgetRendererProps &
  CpWidgetDidiverProps & {
    dontShowDivider?: boolean;
  };

export const CpWidgetRendererWithDivider: React.FC<CpWidgetRendererWithDividerProps> =
  ({ projectId, widget, disabled, nextWidget, dontShowDivider }) => {
    return (
      <>
        <CpWidgetRenderer
          projectId={projectId}
          widget={widget}
          disabled={disabled}
        />
        {dontShowDivider ? null : (
          <CpWidgetDivider nextWidget={nextWidget} widget={widget} />
        )}
      </>
    );
  };
